import { Emitter } from '../emitter/emitter.js';

export class Component extends Emitter {
	getTemplate() {
		return `<div>I'm a component!</div>`;
	}

	getNode() {
		const div = document.createElement('div');
		const template = this.getTemplate();
		div.innerHTML = template;
		const node = div.firstElementChild;
		Array.prototype.slice.call(node.querySelectorAll('img')).forEach(img => {
			img.onerror = () => {
				img.src = '/docs/assets/img/logo-simbolo-rosso.png';
			};
		});
		return node;
	}
}
